import React, { useEffect, useMemo, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ListFetchError from "../components/ListFetchError";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { fetchFaqs } from "../store/faq/faqSlice";

const SUBTITLE =
  "Contrary to popular belief, Lorem Ipsum is not simply random text";

function FAQ({ onOpenAuth, onOpenMenu }) {
  const dispatch = useAppDispatch();
  const faqState = useAppSelector((s) => s.faq);

  const loading = faqState?.status === "loading";
  const error = faqState?.error;
  const faqs = useMemo(() => faqState?.items || [], [faqState?.items]);
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    if (faqState?.status === "idle") dispatch(fetchFaqs());
  }, [faqState?.status, dispatch]);

  const retryFetch = () => {
    if (loading) return;
    dispatch(fetchFaqs());
  };

  useEffect(() => {
    if (openId != null) return;
    if (faqs.length > 0) setOpenId(faqs[0].id);
  }, [faqs, openId]);

  return (
    <div className="min-h-screen bg-[#F5F7FB] text-[#24303A] flex flex-col">
      <Header onOpenAuth={onOpenAuth} onOpenMenu={onOpenMenu} />

      <main className="mx-auto w-full max-w-full flex-1 px-4 py-10 md:px-6">
        <section className="mb-6">
          <h1 className="text-[24px] font-bold text-[#24303A] md:text-[28px]">
            Frequently Asked Questions
          </h1>
          <p className="mt-2 text-[18px] font-semibold text-[#6E7B86]">{SUBTITLE}</p>
        </section>

        <div className="rounded-3xl border border-[#E6EAF0] bg-white shadow-sm overflow-hidden">
          {loading && !error && (
            <div className="flex justify-center py-12">
              <span className="text-[16px] text-slate-500">Loading…</span>
            </div>
          )}

          {error && (
            <div className="p-6">
              <ListFetchError message={error} onRetry={retryFetch} isLoading={loading} />
            </div>
          )}

          {!loading && !error && faqs.length === 0 && (
            <div className="py-12 text-center text-[16px] font-normal text-slate-500">
              No FAQs available.
            </div>
          )}

          {!loading && !error && faqs.length > 0 && (
            <div className="divide-y divide-[#E6EAF0]">
              {faqs.map((faq) => {
                const isOpen = openId === faq.id;
                return (
                  <div key={faq.id} className="border-[#E6EAF0]">
                    <button
                      type="button"
                      onClick={() => setOpenId(isOpen ? null : faq.id)}
                      className="flex w-full items-center justify-between gap-4 px-6 py-4 text-left hover:bg-[#F5F7FB] transition-colors"
                    >
                      <span className="text-[18px] font-bold text-[#24303A]">
                        {faq.question}
                      </span>
                      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-[#E6EAF0] bg-white text-slate-600">
                        {isOpen ? (
                          <svg
                            viewBox="0 0 24 24"
                            className="h-4 w-4"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <path d="M5 12h14" />
                          </svg>
                        ) : (
                          <svg
                            viewBox="0 0 24 24"
                            className="h-4 w-4"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <path d="M12 5v14" />
                            <path d="M5 12h14" />
                          </svg>
                        )}
                      </span>
                    </button>
                    {isOpen && (
                      <div className="px-6 pb-4 pt-0">
                        <p
                          className="text-[16px] font-normal text-[#6E7B86] leading-relaxed"
                          dangerouslySetInnerHTML={{ __html: faq.answer }}
                        />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default FAQ;
